import { ref, onMounted } from 'vue';
import { partnerTableData } from '../../request/api';
import moments from 'moment';
import { useRouter } from "vue-router";

export default function () {
    const router = useRouter()
    // 表格数据
    const filterTableData = ref([]);
    // 总计条数
    const count = ref(0);
    const showLoading = ref(true); //加载loading
    // 表格数据请求方法
    const dataInfo = () => {
        partnerTableData().then((res) => {
            if (res.data.code == 0) {
                filterTableData.value = res.data.data.partnerList;
                count.value = res.data.data.partnerList.length;
                showLoading.value = false;
            }
        })
    }
    // 时间格式化（Element Plus 格式化函数类型）
    const reach = (row, column, cellValue) => {
        if (cellValue) {
            return moments(cellValue * 1000).format("YYYY-MM-DD HH:mm")
        }
        return '';
    };

    // 跳转添加
    const addPartner = () => {
        router.push({ path: '/cooperativeManagement/add' });
    };
    // 跳转编辑
    const editPartner = (id) => {
        router.push({ path: '/cooperativeManagement/edit' })
        sessionStorage.setItem('partnerId', id);
    }
    // 自动加载
    onMounted(() => {
        dataInfo();
    });
    return {
        filterTableData,
        count,
        showLoading,
        reach,
        addPartner,
        editPartner,
        dataInfo
    };
}